import { Box, LinearProgress, Typography, Button } from "@mui/material";

interface ImportProgressProps {
  progress: number;
  total: number;
  onCancel?: () => void;
}

export default function ImportProgress({
  progress,
  total,
  onCancel,
}: ImportProgressProps): JSX.Element {
  const percentage = Math.round((progress / total) * 100);

  return (
    <Box sx={{ mb: 2 }}>
      <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
        <Box sx={{ flexGrow: 1, mr: 2 }}>
          <LinearProgress variant="determinate" value={percentage} />
        </Box>
        <Box sx={{ minWidth: 35 }}>
          <Typography variant="body2" color="text.secondary">
            {`${percentage}%`}
          </Typography>
        </Box>
      </Box>
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Typography variant="body2" color="text.secondary">
          已处理: {progress} / {total}
        </Typography>
        {onCancel && (
          <Button size="small" onClick={onCancel}>
            取消
          </Button>
        )}
      </Box>
    </Box>
  );
}
